/**
 * Validator names as a person reads them.
 *
 * The names are stable identifiers the run record stores verbatim (REQ-OBS-3:
 * the operator sees which validator failed, not "invalid"). But
 * `numeric_substitution` on a queue card tells the Head of Sales nothing
 * about why the pack is in front of them. Unknown names fall through
 * unchanged rather than being hidden.
 */
const LABELS: Record<string, string> = {
  schema: "The draft did not match the required shape",
  numeric_substitution: "The draft contained a figure the code did not compute",
  forbidden_phrases: "The draft used wording a rule forbids",
  required_disclosures: "The draft omitted a required disclosure",
  pii_minimisation: "The draft contained personal data that must not leave the workspace",
  language_parity: "The English and Arabic versions do not match",
  watch_items_traceable: "The draft reported a finding the code did not find",
  anomalies_reported: "The draft left out a finding the code did find",
};

export function validatorLabel(name: string): string {
  return LABELS[name] ?? name;
}
